/*
  SC001（设备参数日报）by赵祥悦 2020/9/2
*/
<template>
  <div class="dailyequipmentparameters mainWrap">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/SC001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.nav29')}}</h1>
              <div style="float:right;display:flex;align-items: center;">
                <label style="margin-right:10px;font-size:12px;">{{$t('Dailyequipment.labelTitle1')}}</label>
                <equipment @change="getchange" class="machinevue" :machine="machineID[1]" :initmachine="initmachine" :hideEquipment='hideEquipment'></equipment>
              </div>
            </div>
            <div class="tableWrap">
                <!-- 标签页 -->
              <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">
                <!-- 二次侧长 -->
                <el-tab-pane :label="$t('Dailyequipment.tabPane1')" v-loading="tabloading">
                  <div style="display:flex;justify-content:space-between;margin-bottom:5px;" v-if="!noMachine">
                    <customDatePicker ref="son" :index="activeName" :machineId="machineID[1]" :time="inittime" @change="getchangedate" v-if="activeName==='0'"></customDatePicker>
                    <el-button type="primary" @click="downloadword(12)" v-show="downloadname"><downloadIcon style="font-size:16px;" title=""/> {{$t('Dailyequipment.download')}}</el-button>
                  </div>
                  <div style="min-height:600px;" v-if="noMachine">
                    <p class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                  </div>
                  <div style="min-height:600px;" v-else>
                    <iframe id="ep" :src="wordsrc" frameborder="0"  style="width:100%;min-height:1000px;" scrolling='auto' v-if="wordsrc!==''"></iframe>
                    <p style="color:red;" v-else>{{$t('Dailyequipment.tabData')}}</p>
                    <!-- <p v-else="wordsrc!==''&&noMachine==true" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</p> -->
                  </div>
                </el-tab-pane>
                <!-- 胎面滚压 -->
                <el-tab-pane :label="$t('Dailyequipment.tabPane2')">
                  <div style="display:flex;justify-content:space-between;margin-bottom:5px;" v-if="!noMachine">
                    <customDatePicker ref="son" :index="activeName" :machineId="machineID[1]"  @change="getchangedate" :time="inittime" v-if="activeName==='1'"></customDatePicker>
                    <el-button type="primary" @click="downloadword(11)" v-show="downloadname"><downloadIcon style="font-size:16px;" title=""/> {{$t('Dailyequipment.download')}}</el-button>
                  </div>
                  <div style="min-height:600px;" v-if="noMachine">
                    <p class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                  </div>
                  <div style="min-height:600px;" v-else>
                    <iframe id="ep" :src="wordsrc" frameborder="0" style="width:100%;min-height:1000px;" scrolling='auto' v-if="wordsrc!==''"></iframe>
                    <p style="color:red;" v-else>{{$t('Dailyequipment.tabData')}}</p>
                    <!-- <p v-else="wordsrc!==''&&noMachine==true" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</p> -->
                  </div>
                </el-tab-pane>
                <!-- 1号带书宽度 -->
                <el-tab-pane :label="$t('Dailyequipment.tabPane3')" v-if="machineID[1]===107||machineID[1]===109">
                  <div style="display:flex;justify-content:space-between;margin-bottom:5px;" v-if="!noMachine">
                    <customDatePicker ref="son" :index="activeName" :machineId="machineID[1]"  @change="getchangedate" :time="inittime" v-if="activeName==='2'"></customDatePicker>
                    <el-button type="primary" @click="downloadword(1)" v-show="downloadname"><downloadIcon style="font-size:16px;" title=""/> {{$t('Dailyequipment.download')}}</el-button>
                  </div>
                  <div style="min-height:600px;" v-if="noMachine">
                    <p class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                  </div>
                  <div style="min-height:600px;" v-else>
                    <iframe id="ep" :src="wordsrc" frameborder="0" style="width:100%;min-height:1000px;" scrolling='auto' v-if="wordsrc!==''" ></iframe>
                    <p style="color:red;" v-else>{{$t('Dailyequipment.tabData')}}</p>
                  </div>
                </el-tab-pane>
                <!-- 2号带书宽度 -->
                <el-tab-pane :label="$t('Dailyequipment.tabPane4')" v-if="machineID[1]===109">
                  <div style="display:flex;justify-content:space-between;margin-bottom:5px;" v-if="!noMachine">
                    <customDatePicker ref="son" :index="activeName" :machineId="machineID[1]"  @change="getchangedate" :time="inittime" v-if="activeName==='3'"></customDatePicker>
                    <el-button type="primary" @click="downloadword(2)" v-show="downloadname"><downloadIcon style="font-size:16px;" title=""/> {{$t('Dailyequipment.download')}}</el-button>
                  </div>
                  <div style="min-height:600px;" v-if="noMachine">
                    <p class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                  </div>
                  <div style="min-height:600px;" v-else>
                    <iframe id="ep" :src="wordsrc" frameborder="0" style="width:100%;min-height:1000px;" scrolling='auto' v-if="wordsrc!==''" ></iframe>
                    <p style="color:red;" v-else>{{$t('Dailyequipment.tabData')}}</p>
                  </div>
                </el-tab-pane>
                <!-- 3号带书宽度 -->
                <el-tab-pane :label="$t('Dailyequipment.tabPane5')" v-if="machineID[1]===107||machineID[1]===109">
                  <div style="display:flex;justify-content:space-between;margin-bottom:5px;" v-if="!noMachine">
                    <customDatePicker ref="son" :index="activeName" :machineId="machineID[1]"  @change="getchangedate" :time="inittime" v-if="machineID[1]===107 ? activeName==='3' : activeName==='4'"></customDatePicker>
                    <el-button type="primary" @click="downloadword(3)" v-show="downloadname"><downloadIcon style="font-size:16px;" title=""/> {{$t('Dailyequipment.download')}}</el-button>
                  </div>
                  <div style="min-height:600px;" v-if="noMachine">
                    <p class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
                  </div>
                  <div style="min-height:600px;" v-else>
                    <iframe id="ep" :src="wordsrc" frameborder="0" style="width:100%;min-height:1000px;" scrolling='auto' v-if="wordsrc!==''" ></iframe>
                    <p style="color:red;" v-else>{{$t('Dailyequipment.tabData')}}</p>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>       
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import customDatePicker from "@/components/CustomDatePicker.vue"
import downloadIcon from "vue-material-design-icons/CloudDownload.vue"
import equipment from "@/components/Equipment.vue"
let timer = new Date();
timer.setDate(1)
export default {
  name: 'SC001',
  components: {
    leftNav,
    customDatePicker,
    downloadIcon,
    equipment
  },
  data () {
    return {
        fullscreenLoading:false,
            //  车间数据
        options: [],
        // 选中的机械id
        machineID: [],
        // 胎面表格数据
        treadtableData:[],
        //  胎面车号信息
        statisticTreadList:{},
        //  胎面头部表格信息
        treadInfo:{},
        // 栅格车号
        treadCarNum: '',
        // 胎面表格升降序
        treadSort: '',
        // tab的id
        tabCods: 88195,
        // loading
        loading: false,
        // 公差值
        tolerance:{
            standard:'',
            up:'',
            low:''
        },
        showPopup:false,
        // 时间选择器
        dateValue: '',
        treadTablePage:'0',
        timeType: '',
        selectActive: '0',
        saveInfo: '',
        tabloading:false,
        activeName:'0',
        // 选择的月份 例：2020-09
        currentMonth:'',
        currentMonth2:'',
        currentMonth3:'',
        wordsrc:'',
        // 要下载文件的文件名
        downloadname:'',
        prevmonth:0,//往前导几个月
        //现在月份的一号
        nowdate:'',
        // 获取到报表的日期
        inittime:'',
        // 访问的url
        locaurl:'',
        // 标记选的是哪个标签页，然后对应的type值
        changetype:'',
        // 初始化时显示的是哪个设备的日报
        initmachine:'',
        //临时要隐藏的设备的ID
        hideEquipment:[101,110,111,113,114,115],
        noMachine:false
    }
  },
  created () {
    // if (this.$store.state.reloadState === false) {
    //   this.$store.state.reloadState = true
    //   // this.$parent.reload()
    // }else{
      this.getManiceList()
      this.locaurl="http://"+this.$store.state.websocketws
    // }
  },
  mounted() {
      // this.init()
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    },
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=value
      this.activeName='0'
      this.changetype='12'
      this.getTableData()
    },
    //获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {  
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            _this.noMachine=false     
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options[0].children
            _this.init()
          }else{
            _this.options = res.data.options
            _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 切换车间重新获取数
    getTableData(){
      this.selectActive = 0
      let nowDate = new Date()
      let nowformatDate = formatDate(nowDate, 'yyyy-MM-dd')
      this.dateValue= nowformatDate
      let _this = this
      _this.wordsrc=''
      _this.tabloading=true
      let signTime = new Date().getTime()
      _this.$store.commit('nowsign', signTime)
      _this.axios({
        method: 'get',
        url: '/url/dailyEquipmentParameterFileName',
        params:{
          type:Number(_this.activeName)+1,
          machineId:_this.machineID[1],
          language: _this.$store.state.lang,
        }
      }).then(function(res){
        _this.downloadname=res.data.fileName
        _this.inittime=res.data.time
        _this.tabloading=false
        if(res.data.success==='true'){
          _this.wordsrc=_this.$store.state.officeUrl+'/wv/wordviewerframe.aspx?WOPISrc='+_this.locaurl+'url/wopi/files/dailyEquipmentParametersDownload/'+_this.$store.state.newroute+'/'+_this.$store.state.authCode+'/'+_this.$store.state.factoryId+'/'+_this.$store.state.sign+'/'+signTime+'/'+_this.inittime+'/'+_this.changetype+'/'+_this.machineID[1]
        }
      })
    },
    handleClick(tab){
      let _this = this
      if(this.machineID[1]===107){
        if(Number(tab.index)===0){
          _this.changetype=12
        }else if(Number(tab.index)===1){
          _this.changetype=11
        }else if(Number(tab.index)===2){
          _this.changetype=1
        }else if(Number(tab.index)===3){
          _this.changetype=3
        }
      }else{
        if(Number(tab.index)===0){
          _this.changetype=12
        }else if(Number(tab.index)===1){
          _this.changetype=11
        }else if(Number(tab.index)===2){
          _this.changetype=1
        }else if(Number(tab.index)===3){
          _this.changetype=2
        }else if(Number(tab.index)===4){
          _this.changetype=3
        }
      }
      
      let signTime = new Date().getTime()
      _this.$store.commit('nowsign', signTime)
      _this.wordsrc=''
      _this.inittime=''
      _this.downloadname=''
      _this.tabloading=true
      _this.axios({
        method: 'get',
        url: '/url/dailyEquipmentParameterFileName',
        params:{
          type:Number(tab.index)+1,
          machineId:_this.machineID[1],
          language: _this.$store.state.lang,
        }
      }).then(function(res){
        _this.downloadname=res.data.fileName
        _this.inittime=res.data.time
        _this.tabloading=false
        if(res.data.success==='true'){
          _this.wordsrc=_this.$store.state.officeUrl+'/wv/wordviewerframe.aspx?WOPISrc='+_this.locaurl+'url/wopi/files/dailyEquipmentParametersDownload/'+_this.$store.state.newroute+'/'+_this.$store.state.authCode+'/'+_this.$store.state.factoryId+'/'+_this.$store.state.sign+'/'+signTime+'/'+_this.inittime+'/'+_this.changetype+'/'+_this.machineID[1]
        }
      })
    },
    // 点击下载
    downloadword(type){
      let _this = this
      let signTime = new Date().getTime()
      _this.$store.commit('nowsign', signTime)
      window.open('/url/wopi/files/dailyEquipmentParametersDownload/'+_this.$store.state.newroute + '/'+ _this.$store.state.authCode + '/'+ _this.$store.state.factoryId + '/'+ _this.$store.state.sign +'/'+signTime+'/'+_this.inittime+'/'+type+'/'+_this.machineID[1]+'/'+'contents', '_blank')
    },
    getchangedate(data,name){
      let _this =this
      if(name===''){
        this.$message.error(this.$t('Dailyequipment.changenodata'))
      }else{
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        this.inittime=data
        this.downloadname=name
        _this.wordsrc=_this.$store.state.officeUrl+'/wv/wordviewerframe.aspx?WOPISrc='+_this.locaurl+'url/wopi/files/dailyEquipmentParametersDownload/'+_this.$store.state.newroute+'/'+_this.$store.state.authCode+'/'+_this.$store.state.factoryId+'/'+_this.$store.state.sign+'/'+signTime+'/'+_this.inittime+'/'+_this.changetype+'/'+_this.machineID[1]
      }
    },
    init(){
      let _this = this
      _this.tabloading=true
      let signTime = new Date().getTime()
      _this.$store.commit('nowsign', signTime)
      let str = '1,2,3,4,5'
      _this.axios({
        method: 'get',
        url: '/url/dailyEquipmentParameterFirstFileName',
        params:{
          typeList:str,
          language: _this.$store.state.lang,
        }
      }).then(function(res){
        if(res.data.success=='true'){
          _this.activeName=String(res.data.filetype-1)
          _this.machineID[0]=Number(_this.$store.state.defaultFactoryId)
          _this.machineID[1]=res.data.machineId
          _this.changetype=res.data.fileSaveType
          _this.options.forEach(element => {
            if(res.data.machineId===element.value){
              _this.initmachine=element.label
            }
          });
          _this.inittime=res.data.dayTime
          _this.downloadname=res.data.fileName
          _this.wordsrc=_this.$store.state.officeUrl+'/wv/wordviewerframe.aspx?WOPISrc='+_this.locaurl+'url/wopi/files/dailyEquipmentParametersDownload/'+_this.$store.state.newroute+'/'+_this.$store.state.authCode+'/'+_this.$store.state.factoryId+'/'+_this.$store.state.sign+'/'+signTime+'/'+_this.inittime+'/12'+'/'+_this.machineID[1]
          _this.tabloading=false
        }else{
          _this.tabloading=false

          _this.$message.error(res.data.msg)
        }
      })
    },
  }
  
}
</script>
<style>
.sc001calendar .el-calendar-table thead th{
  text-align:center!important;
}
</style>
<style scoped>
.ReloadingStatistics{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  padding-bottom: 30px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  margin: 20px 15px;
}
.el-calendar-day p{
    text-align:right;
}
.yearMonths{
    width: 118px;
    position: absolute;
    right: 230px;
    top: 11px;
    height: 28px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    overflow: hidden;
}
.yearMonths .yearMonths-box{
    position: absolute;
    top: -6px;
    left:-1px;
}
.downloadbox{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nextMonth{
    /* display: none; */
    position: absolute;
    top: 12px;
    right: 20px;
    z-index: 10;
    border:1px solid #DCDFE6;
    border-left: none;
    color: #C0C4CC;
    font-size: 12px;
    line-height: 12px;
    /* height: 26px; */
    /* width: 66px; */
    padding: 7px 15px;
    text-align: center;
    border-radius: 0 3px 3px 0;
    background-color: #F5F7FA;
    cursor:no-drop;/* 鼠标悬浮禁用 */
    user-select: none;
    font-family: "Arial";
}
.yearMonths-right{
  right: 310px;
}
.current .el-calendar-day .downloadbox{
    color:#3782E4;
    font-size:18px;
}
.prev .el-calendar-day .downloadbox{
    color:#B2D2F5;
    font-size:18px;
}
.next .el-calendar-day .downloadbox{
    color:#B2D2F5;
    font-size:18px;
}
.el-calendar-table td.is-selected{
    background:#fff!important;
    color:#3782E4!important;
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
}
</style>

